module.exports = __webpack_public_path__ + "assets/img/icon-badge-b10bd465.png";